/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

// localStorage can be null or throw on access in some browsers/webviews (privacy modes)
const getStorage = (): Storage | null => {
  try {
    return typeof window !== 'undefined' && window.localStorage
      ? window.localStorage
      : null;
  } catch {
    return null;
  }
};

export const getSafeLocalStorageItem = (key: string): string | null => {
  try {
    return getStorage()?.getItem(key) ?? null;
  } catch {
    return null;
  }
};

export const setSafeLocalStorageItem = (key: string, value: string) => {
  try {
    getStorage()?.setItem(key, value);
  } catch {
    // best-effort
  }
};

export const removeSafeLocalStorageItem = (key: string) => {
  try {
    getStorage()?.removeItem(key);
  } catch {
    // best-effort
  }
};
